import Styles from "./SideNavBar.module.css";
import sidebarCompanyIcon from "../../assets/images/companIcon.svg";
import panelClose from "../../assets/images/panelClose.svg";
import { ReactComponent as UserRoundPen } from "../../assets/images/UserRoundPen.svg";
import { ReactComponent as Bess } from "../../assets/images/bessIcon.svg";
import { ReactComponent as BessOrange } from "../../assets/images/BessOrange.svg";
import { ReactComponent as ArcIcon } from "../../assets/images/arcIcon.svg";
import { ReactComponent as LccIcon } from "../../assets/images/lccIcon.svg";
import { ReactComponent as BuySell } from "../../assets/images/buySellGrey.svg";
import { ReactComponent as BuySellOrange } from "../../assets/images/buySellOrnage.svg";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { loginSwitchService } from "../../Services/ApiCalling/Auth";
import { activeLoading } from "../../Redux/Slices/notificationSlice";
import { login, logout } from "../../Redux/Slices/authSlice";
import { ErrorMessage } from "../../commons/Toast/ErrorMessage";
import RaDateCHange from "../Modals/RaDateChange/RaDateCHange";
import { ReactComponent as GenIconGrey } from "../../assets/images/genIconGrey.svg";
import { ReactComponent as DiscomIconGrey } from "../../assets/images/BankingGrey.svg";
import { ReactComponent as BankingOrange } from "../../assets/images/BankingOrange.svg";
import { ReactComponent as ConsumerGrey } from "../../assets/images/consumerGrey.svg";
import { ReactComponent as CompanyAdminIconGrey } from "../../assets/images/compAdminGrey.svg";
import { ReactComponent as CompanyAdminIconOrange } from "../../assets/images/compAdminOrangesvg.svg";
import { ReactComponent as ConsumerOrange } from "../../assets/images/ConsumerOrange.svg";
import { ReactComponent as GeneratorOrange } from "../../assets/images/GeneratorOrange.svg";
import { ReactComponent as BankingLedgerOrange } from "../../assets/images/BankingLedgerOrange.svg";
import { ReactComponent as BankingLedgerGrey } from "../../assets/images/BankingLedgerGrey.svg";
import { ReactComponent as SearchBankingOrange } from "../../assets/images/SeaBankOrange.svg";
import { ReactComponent as SearchBankingGrey } from "../../assets/images/SeaBankGrey.svg";
import { ReactComponent as ProfileOrange } from "../../assets/images/profileOrange.svg";
import { ReactComponent as EscrowOrange } from "../../assets/images/escrowOrange.svg";
import { ReactComponent as EscrowGrey } from "../../assets/images/escrowGrey.svg";
import { ReactComponent as ArchiveOrange } from "../../assets/images/archiveOrange.svg";
import { ReactComponent as LccOrange } from "../../assets/images/LCCorange.svg";
import { ReactComponent as LccGrey } from "../../assets/images/LCCgrey.svg";
import { ReactComponent as RfqGrey } from "../../assets/images/rfqGrey.svg";
import { ReactComponent as RfqOrange } from "../../assets/images/rfqOrange.svg";
import { ReactComponent as ReverseAucGrey } from "../../assets/images/reverseAucGrey.svg";
import { ReactComponent as ReverseAucOrange } from "../../assets/images/reverseAucOrange.svg";
import { ReactComponent as BilateralGrey } from "../../assets/images/bilateralGrey.svg";
import { ReactComponent as BilateralOrange } from "../../assets/images/bilateralAnotherOrange.svg";
import { ReactComponent as VppaGrey } from "../../assets/images/vpGrey.svg";
import { ReactComponent as VppaOrange } from "../../assets/images/vpOrange.svg";
import { ReactComponent as RecGrey } from "../../assets/images/recGrey.svg";
import { ReactComponent as RecOrange } from "../../assets/images/recOrange.svg";
import { ReactComponent as LogoutGrey } from "../../assets/images/logoutGrey.svg";
import { ReactComponent as LogoutOrange } from "../../assets/images/logoutOrange.svg";
import {
  emptyCounterPartyList,
  emptySelfList,
  fetchSelfCapacity,
  fetchSideBarConsumerList,
  fetchSideBarGeneratorsList,
  fetchSideBarList,
  setActiveListingId,
} from "../../Redux/Slices/CapacitySlice";
import { setActiveRegion } from "../../Redux/Slices/activeRegionSlice";
import { setActiveEntity } from "../../Redux/Slices/activeEntitySlice";
import { setActiveSidebarItem } from "../../Redux/Slices/activeEntitySlice";

const Banking = [
  {
    name: "Dashboard",
    link: "/banking",
    Icon: DiscomIconGrey,
    HoverIcon: BankingOrange,
  },
  {
    name: "My Banking Ledger",
    link: "/banking_ledger",
    Icon: BankingLedgerGrey,
    HoverIcon: BankingLedgerOrange,
  },
  {
    name: "Available Banking",
    link: "/banking_search",
    Icon: SearchBankingGrey,
    HoverIcon: SearchBankingOrange,
  },
];

const ProfileLinks = [
  {
    name: "My Profile",
    link: "/my_profile",
    Icon: UserRoundPen,
    HoverIcon: ProfileOrange,
  },
  {
    name: "Escrow",
    link: "/wallet",
    Icon: EscrowGrey,
    HoverIcon: EscrowOrange,
  },
  {
    name: "Archive",
    link: "/archive",
    Icon: ArcIcon,
    HoverIcon: ArchiveOrange,
  },
  {
    name: "Unified Ledger",
    link: "/unified_ledger",
    Icon: LccIcon,
    HoverIcon: LccOrange,
  },
  // {
  //   name: "Company Admin",
  //   link: "/admin_company_dashboard",
  //   Icon: CompanyAdminIconGrey,
  //   HoverIcon: CompanyAdminIconOrange,
  // },
  // { name: "LCC", link: "/lcc", Icon: LccGrey, HoverIcon: LccOrange },
  { name: "Logout", link: "/login", Icon: LogoutGrey, HoverIcon: LogoutOrange },
];

const ProductLinks_Banking = [
  {
    name: "Banking",
    link: "/banking",
    Icon: DiscomIconGrey,
    HoverIcon: BankingOrange,
    navOption: "Banking",
  },
];

const ProductLinks_BuySell = [
  {
    name: "Buy/Sell",
    link: "/dashboard",
    Icon: BuySell,
    HoverIcon: BuySellOrange,
    navOption: "BuySellNav",
  },
  { name: "BESS", link: "/coming-soon", Icon: Bess, HoverIcon: BessOrange },
  { name: "REC", link: "/coming-soon", Icon: RecGrey, HoverIcon: RecOrange },
  { name: "VPPA", link: "/coming-soon", Icon: VppaGrey, HoverIcon: VppaOrange },
];

const roleIcons = {
  CONSUMER: ConsumerGrey,
  GENERATOR: GenIconGrey,
  BANKING: DiscomIconGrey,
  COMPANY_ADMIN: CompanyAdminIconGrey,
};

const roleIconsHover = {
  CONSUMER: ConsumerOrange,
  GENERATOR: GeneratorOrange,
  BANKING: BankingOrange,
  COMPANY_ADMIN: CompanyAdminIconOrange,
};

const SideNavBar = ({ userType, navOpen, onNavSwitch }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const company = useSelector((state) => state?.persistedReducer?.company);
  const state = useSelector(
    (store) => store?.persistedReducer?.company?.stateLabel,
  );
  const data = useSelector((state) => state?.persistedReducer);
  const [activeProduct, setActiveProduct] = useState("");
  const [hoverProduct, setHoverProduct] = useState("");
  const [userSelect, setUserSelect] = useState("");
  const [entitySelection, setEntitySelection] = useState({});
  const [search, setSearch] = useState("");
  const user = useSelector(
    (state) => state.persistedReducer.user?.activeRole
  )?.toLowerCase();

  const name = useSelector(
    (state) => state.persistedReducer.user?.user?.fullName
  );
  const [activeProfile, setActiveProfile] = useState(() => {
    const profileRoute = ProfileLinks?.find(
      (ele) => ele?.link === location?.pathname
    );
    if (profileRoute) return profileRoute.name;
    return "";
  });

  const BuySellNav = React.useMemo(
    () => [
      {
        view: true,
        name: "Bilateral",
        link: "/dashboard",
        Icon: BilateralGrey,
        HoverIcon: BilateralOrange,
        children: [
          {
            label:
              user === "consumer"
                ? "All Sell Listings"
                : user === "generator"
                ? "All Buy Listings"
                : "Available Bilateral",
            link: "/search_listing",
            Icon: SearchBankingGrey,
            HoverIcon: SearchBankingOrange,
          },
        ],
      },
      // {
      //   name: "Available Bilateral",
      //   link: "/search_listing",
      //   Icon: SearchBankingGrey,
      //   HoverIcon: SearchBankingOrange,
      // },
      {
        view: state !== "OD",
        name: "RFP/RFQ",
        link: "/rfq",
        Icon: RfqGrey,
        HoverIcon: RfqOrange,
      },
      {
        view:
          (process.env.REACT_APP_ENV === "qa" ||
            process.env.REACT_APP_ENV === "stage") &&
          state !== "OD",
        name: "Reverse Auction",
        link: "/reverse_auction",
        Icon: ReverseAucGrey,
        HoverIcon: ReverseAucOrange,
      },
      {
        view: state === "OD",
        name: "TradeConnect",
        link: "/rfq",
        Icon: RfqGrey,
        HoverIcon: RfqOrange,
        children: [
          {
            label: "RFP/RFQ",
            link: "/rfq",
            Icon: RfqGrey,
            HoverIcon: RfqOrange,
          },
          {
            view: true,
            label: "Reverse Auction",
            name: "Reverse Auction",
            link: "/reverse_auction",
            Icon: ReverseAucGrey,
            HoverIcon: ReverseAucOrange,
          },
        ],
      },
    ],
    [state, user],
  );

  const [activeLocation, setActiveLocation] = useState(() => {
    const bankingRoute = Banking?.find(
      (ele) => ele?.link === location?.pathname
    );
    if (bankingRoute) {
      dispatch(setActiveSidebarItem(bankingRoute.name));
      return bankingRoute.name;
    }

    const buySellRoute = BuySellNav?.find(
      (ele) => ele?.link === location?.pathname
    );
    if (buySellRoute) {
      dispatch(setActiveSidebarItem(buySellRoute.name));
      return buySellRoute.name;
    }

    for (const parent of BuySellNav) {
      if (parent.children) {
        const childRoute = parent.children.find(
          (child) => child?.link === location?.pathname
        );
        if (childRoute) {
          dispatch(setActiveSidebarItem(childRoute.label));
          return childRoute.label;
        }
      }
    }

    return "";
  });

  const [hoverLocation, setHoverLocation] = useState("");
  const [hoverRole, setHoverRole] = useState("");

  const [raChange, setRaChange] = useState(false);

  const [hoverProfile, setHoverProfile] = useState("");
  const [hoverCollapsedProduct, setHoverCollapsedProduct] = useState("");
  const [hoverCollapsedSubItem, setHoverCollapsedSubItem] = useState("");
  const [expandedProducts, setExpandedProducts] = useState(() => {
    const initialExpanded = {};
    for (const parent of BuySellNav) {
      if (parent.children) {
        const childRoute = parent.children.find(
          (child) => child?.link === location?.pathname
        );
        if (childRoute) {
          initialExpanded[parent.name] = true;
        }
      }
    }

    return initialExpanded;
  });

  const [manuallyCollapsed, setManuallyCollapsed] = useState({});

  const getRedirectPath = (role) => {
    switch (role) {
      case "SUPER_ADMIN":
      case "MAKER":
      case "CHECKER":
      case "ADMIN":
        return "/admin_dashboard";
      case "ANALYST":
        return "/analyst_dashboard";
      case "TRADER":
        return "/trader_dashboard";
      case "BANKING":
        return "/banking";
      case "COMPANY_ADMIN":
        return "/admin_company_dashboard";
      case "CONSUMER":
      case "GENERATOR":
        return "/dashboard";
      default:
        return "/dashboard";
    }
  };

  useEffect(() => {
    dispatch(fetchSideBarList());
  }, [dispatch]);

  const sideBarList = useSelector(
    (state) => state.CapacitySlice.fetchSideBarList
  );
  const generators = sideBarList?.generators || [];
  const consumers = sideBarList?.consumers || [];
  const discoms = sideBarList?.discoms || [];
  const roles = sideBarList?.roles || [];

  useEffect(() => {
    if (data?.userType === "BANKING") {
      setActiveProduct("Banking");
    } else {
      setActiveProduct("Buy/Sell");
    }
  }, [location?.pathname, data?.userType]);

  useEffect(() => {
    const bankingRoute = Banking?.find(
      (ele) => ele?.link === location?.pathname
    );
    if (bankingRoute) {
      dispatch(setActiveSidebarItem(bankingRoute.name));
      setActiveLocation(bankingRoute.name);
      setActiveProfile("");
      return;
    }

    const buySellRoute = BuySellNav?.find(
      (ele) => ele?.link === location?.pathname
    );
    if (buySellRoute) {
      dispatch(setActiveSidebarItem(buySellRoute.name));
      setActiveLocation(buySellRoute.name);
      setActiveProfile("");
      if (
        buySellRoute.children?.length > 0 &&
        !manuallyCollapsed[buySellRoute.name]
      ) {
        setExpandedProducts((prev) => ({
          ...prev,
          [buySellRoute.name]: true,
        }));
      }
      return;
    }

    for (const parent of BuySellNav) {
      if (parent.children) {
        const childRoute = parent.children.find(
          (child) => child?.link === location?.pathname
        );
        if (childRoute) {
          dispatch(setActiveSidebarItem(parent.name));
          setActiveLocation(childRoute.label);
          setActiveProfile("");
          if (!manuallyCollapsed[parent.name]) {
            setExpandedProducts((prev) => ({
              ...prev,
              [parent.name]: true,
            }));
          }
          return;
        }
      }
    }

    const profileRoute = ProfileLinks?.find(
      (ele) => ele?.link === location?.pathname
    );
    if (profileRoute) {
      setActiveProfile(profileRoute.name);
      setActiveLocation("");
      return;
    }

    setActiveLocation("");
    setActiveProfile("");
  }, [BuySellNav, dispatch, location?.pathname, manuallyCollapsed]);

  function getProductName(user) {
    if (user === "consumer") {
      return "Buy";
    } else if (user === "generator") {
      return "Sell";
    }
    return "";
  }

  const handleProductToggle = (productName) => {
    setExpandedProducts((prevState) => {
      const newValue = !prevState[productName];
      if (!newValue) {
        setManuallyCollapsed((prev) => ({
          ...prev,
          [productName]: true,
        }));
      } else {
        setManuallyCollapsed((prev) => ({
          ...prev,
          [productName]: false,
        }));
      }
      return {
        ...prevState,
        [productName]: newValue,
      };
    });
  };
  const handleSwitchUser = async (ele, id, displayName) => {
    let payload = {
      switchRole: ele,
      switchCompanyId: null,
      switchConsumerId: ele === "CONSUMER" ? id : null,
      switchGeneratorId: ele === "GENERATOR" ? id : null,
      switchDiscomId: ele === "BANKING" ? discoms?.[0]?.discomId : null,
    };
    let res = await loginSwitchService(payload);
    dispatch(activeLoading(true));
    if (res?.data?.code === 200) {
      dispatch(setActiveListingId(null));
      dispatch(emptyCounterPartyList());
      dispatch(emptySelfList());
      dispatch(login(res?.data?.data));
      dispatch(setActiveRegion(res?.data?.data?.activeUserRegionName || ""));
      localStorage.setItem("OTC_V2_TOKEN", res?.data?.data?.token);
      if (
        res?.data?.data?.activeRole === "CONSUMER" ||
        res?.data?.data?.activeRole === "GENERATOR"
      ) {
        localStorage.setItem(
          "OTC_V2_ACTIVE_REGION",
          res?.data?.data?.activeUserRegionName || ""
        );
      }
      dispatch(setActiveEntity(displayName || ""));
      navigate(getRedirectPath(res?.data?.data?.activeRole));
      setTimeout(() => {
        dispatch(activeLoading(false));
      }, 4000);

      const newActiveRole = res?.data?.data?.activeRole?.toLowerCase();
      const newUserType = res?.data?.data?.activeRole;
      const userName = res?.data?.data?.user?.fullName;

      if (newActiveRole && newUserType !== "COMPANY_ADMIN" && userName) {
        dispatch(fetchSelfCapacity({ user: newActiveRole }));
      }
    } else {
      dispatch(activeLoading(false));
      ErrorMessage(res?.data?.error || "Invalid username or password");
    }
  };

  function getActiveEntityName(data, discoms) {
    const entityName =
      data?.consumer?.find(
        (ele) => ele?.consumerId === data?.user?.activeConsumerId
      )?.consumerName ||
      data?.generator?.find(
        (ele) => ele?.generatorId === data?.user?.activeGeneratorId
      )?.generatorName ||
      discoms?.find((ele) => ele?.discomId === data?.user?.activeDiscomId)
        ?.acronym ||
      "Entity Name";
    dispatch(setActiveEntity(entityName));
    return entityName;
  }

  const handleUserSelect = (data) => {
    if (data === userSelect) return setUserSelect("");
    setUserSelect(data);
  };

  const handleSearch = (e, value) => {
    e.stopPropagation();
    e.preventDefault();
    setSearch(value);
  };
  const searchInputRef = React.useRef(null);
  React.useEffect(() => {
    if (userSelect && searchInputRef.current) {
      setTimeout(() => {
        searchInputRef.current.focus();
      }, 0);
    }
  }, [userSelect]);

  return (
    <>
      {raChange && (
        <RaDateCHange open={raChange} handleClose={() => setRaChange(false)} />
      )}
      <div className={`${Styles.side_nav_main_cont} `}>
        {navOpen ? (
          <>
            {data?.userType === "SUPER_ADMIN" ? (
              <></>
            ) : (
              <>
                <div className={Styles.content_Side_Container}>
                  <div className={Styles.side_nav_icon}>
                    <img
                      width={20}
                      height={20}
                      src={sidebarCompanyIcon}
                      alt="sidebarCompanyIcon"
                    />
                    <span className={Styles.companyWrapper}>
                      <span className={Styles.company_name}>
                        {company?.companyName || "Company Name"}
                      </span>

                      <span className={Styles.tooltip}>
                        {company?.companyName || "Company Name"}
                      </span>
                    </span>
                  </div>

                  <img
                    width={18}
                    height={18}
                    src={panelClose}
                    alt="Close Panel"
                    onClick={onNavSwitch}
                  />
                </div>

                <div
                  className={`${Styles.productCommonContainer} scroll_bar_y`}
                >
                  <div className={Styles.contentHeader}>
                    <div className={Styles.contentHeaderText}>Entity</div>

                    <div>
                      {data?.roles
                        ?.filter(
                          (role) => role !== "TRADER" && role !== "ADMIN_TRADER"
                        )
                        ?.map((role) => {
                          const Icon =
                            hoverRole === role ||
                            role === data?.userType ||
                            userSelect === role
                              ? roleIconsHover[role] || BuySell
                              : roleIcons[role] || BuySell;

                          return (
                            <div
                              onClick={() =>
                                role === "COMPANY_ADMIN"
                                  ? handleSwitchUser(role, "")
                                  : handleUserSelect(role)
                              }
                              onMouseEnter={() => setHoverRole(role)}
                              onMouseLeave={() => setHoverRole("")}
                              key={role}
                              style={{ cursor: "pointer" }}
                            >
                              <div
                                className={`display_flex_row ${
                                  role === data?.userType
                                    ? `${Styles.roleContainerMainActive}`
                                    : Styles.roleContainerMain
                                } ${
                                  role === userSelect && Styles.roleContDropDown
                                }`}
                              >
                                <div
                                  className={`${
                                    role === data?.userType
                                      ? Styles.sessionAction
                                      : Styles.sessionInactive
                                  }`}
                                ></div>

                                <div
                                  className={`display_flex_row_center ${
                                    Styles.roleIcon
                                  } ${
                                    hoverRole === role
                                      ? Styles.roleIconHover
                                      : ""
                                  }`}
                                >
                                  <Icon
                                    style={{
                                      height: "15px",
                                      width: "15px",
                                      transition: "all 0.3s ease",
                                    }}
                                    className={
                                      hoverRole === role
                                        ? Styles.iconHovered
                                        : ""
                                    }
                                  />
                                </div>

                                {!(role === "COMPANY_ADMIN") &&
                                (role === data?.userType ||
                                  role === userSelect) ? (
                                  <div className={`${Styles.roleText}`}>
                                    <div className={Styles.activeMainRoleName}>
                                      {role === "CONSUMER"
                                        ? "Buyer"
                                        : role === "GENERATOR"
                                        ? "Seller"
                                        : role === "BANKING"
                                        ? "Banking"
                                        : "User"}
                                    </div>

                                    {role === userSelect ? (
                                      <div
                                        // className={
                                        //   Styles.inputSelectionContainer
                                        // }
                                        className={
                                          Styles.inputTextMainContainer
                                        }
                                        onClick={(e) => e.stopPropagation()}
                                      >
                                        <input
                                          type="text"
                                          ref={searchInputRef}
                                          // className={Styles.searchInput}
                                          className={Styles.inputColorText}
                                          placeholder="Search name"
                                          onChange={(e) =>
                                            handleSearch(e, e.target.value)
                                          }
                                        />
                                      </div>
                                    ) : (
                                      <div
                                        className={Styles.actievRoleName}
                                        title={getActiveEntityName(
                                          data,
                                          discoms,
                                        )}
                                      >
                                        {getActiveEntityName(data, discoms)}
                                      </div>
                                    )}
                                  </div>
                                ) : (
                                  <div
                                    className={`${Styles.roleText} ${
                                      role === "COMPANY_ADMIN"
                                        ? Styles.companyAdmin
                                        : ""
                                    }`}
                                  >
                                    {role === "CONSUMER"
                                      ? "Buyer"
                                      : role === "GENERATOR"
                                      ? "Seller"
                                      : role === "BANKING"
                                      ? "Banking"
                                      : role === "COMPANY_ADMIN"
                                      ? "Company Admin"
                                      : "User"}
                                  </div>
                                )}

                                <div className={Styles.dropDownElem}>
                                  {!(role === "COMPANY_ADMIN") && (
                                    <KeyboardArrowDownIcon
                                      style={{ fontSize: "12px" }}
                                    />
                                  )}
                                </div>
                              </div>

                              <div
                                className={`scroll_bar_y ${
                                  userSelect === role
                                    ? Styles.dropdownContent
                                    : Styles.dropdownContentInactive
                                }`}
                              >
                                {userSelect === role &&
                                  (role === "CONSUMER"
                                    ? consumers
                                    : role === "GENERATOR"
                                    ? generators
                                    : role === "BANKING"
                                    ? discoms || []
                                    : []
                                  )
                                    ?.filter((user) => {
                                      if (!search) return true;
                                      const name =
                                        role === "BANKING"
                                          ? user?.discomName || ""
                                          : user?.consumerName ||
                                            user?.generatorName ||
                                            "";
                                      return name
                                        .toLowerCase()
                                        .includes(search.toLowerCase());
                                    })
                                    ?.map((user) => {
                                      const UserIcon =
                                        role === "CONSUMER" &&
                                        entitySelection?.consumerId ===
                                          user?.consumerId
                                          ? ConsumerOrange
                                          : role === "GENERATOR" &&
                                            entitySelection?.generatorId ===
                                              user?.generatorId
                                          ? GeneratorOrange
                                          : role === "BANKING" &&
                                            entitySelection?.discomId ===
                                              user?.discomId
                                          ? BankingOrange
                                          : roleIcons[role] || BuySell;

                                      const userId =
                                        role === "BANKING"
                                          ? user?.discomId
                                          : user?.consumerId ||
                                            user?.generatorId ||
                                            "";

                                      const displayName =
                                        role === "BANKING"
                                          ? user?.acronym
                                          : user?.consumerName ||
                                            user?.generatorName;

                                      return (
                                        <div
                                          key={userId}
                                          className={`display_flex_row_gap_8_only ${
                                            Styles.userListSelection
                                          } ${Styles.userListOther} ${
                                            (role === "CONSUMER" &&
                                              entitySelection?.consumerId ===
                                                user?.consumerId) ||
                                            (role === "GENERATOR" &&
                                              entitySelection?.generatorId ===
                                                user?.generatorId) ||
                                            (role === "BANKING" &&
                                              entitySelection?.discomId ===
                                                user?.discomId)
                                              ? Styles.userListMainSelectionActive
                                              : ""
                                          }`}
                                          onMouseEnter={() =>
                                            setEntitySelection(user)
                                          }
                                          onMouseLeave={() =>
                                            setEntitySelection({})
                                          }
                                          onClick={() =>
                                            handleSwitchUser(
                                              role,
                                              userId,
                                              displayName
                                            )
                                          }
                                        >
                                          <div
                                            className={`${
                                              (role === "CONSUMER" &&
                                                entitySelection?.consumerId ===
                                                  user?.consumerId) ||
                                              (role === "GENERATOR" &&
                                                entitySelection?.generatorId ===
                                                  user?.generatorId) ||
                                              (role === "BANKING" &&
                                                entitySelection?.discomId ===
                                                  user?.discomId)
                                                ? Styles.userListSelectionActive
                                                : Styles.userListSelectionInactive
                                            }`}
                                          ></div>

                                          {/* <UserIcon
                                            style={{
                                              height: "15px",
                                              width: "15px",
                                              transition: "all 0.3s ease",
                                            }}
                                            className={
                                              (role === "CONSUMER" &&
                                                entitySelection?.consumerId ===
                                                  user?.consumerId) ||
                                              (role === "GENERATOR" &&
                                                entitySelection?.generatorId ===
                                                  user?.generatorId) ||
                                              (role === "BANKING" &&
                                                entitySelection?.discomId ===
                                                  user?.discomId)
                                                ? Styles.iconHovered
                                                : ""
                                            }
                                          /> */}
                                          {/* <div style={{}}></div> */}

                                          {/* <div className={Styles.userText}>
                                            {displayName}
                                            <span className={Styles.tooltip}>
                                              {displayName}
                                            </span>
                                          </div> */}
                                          <div className={Styles.userText}>
                                            <div
                                              className={Styles.userTextContent}
                                            >
                                              {displayName}
                                            </div>
                                            <span className={Styles.tooltip}>
                                              {displayName}
                                            </span>
                                          </div>
                                        </div>
                                      );
                                    })}
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>

                  {data?.userType !== "COMPANY_ADMIN" && (
                    <div className={Styles.contentHeader}>
                      <div className={Styles.contentHeaderText}>Products</div>
                      <div>
                        {(data?.userType === "BANKING"
                          ? ProductLinks_Banking
                          : ProductLinks_BuySell
                        )?.map((product) => {
                          const IconToUse =
                            (activeProduct === product?.name ||
                              hoverProduct === product?.name) &&
                            product?.HoverIcon
                              ? product.HoverIcon
                              : product.Icon;
                          return (
                            <div
                              key={product.name}
                              onMouseEnter={() => {
                                setHoverProduct(product?.name);
                              }}
                              onMouseLeave={() => setHoverProduct("")}
                            >
                              <div
                                onClick={() => {
                                  navigate(product?.link);
                                }}
                                className={`display_flex_row_gap_4_only ${
                                  activeProduct === product?.name
                                    ? ` ${Styles.productRoleActive}`
                                    : Styles.roleContainerMain
                                } ${
                                  activeProduct === product?.name &&
                                  Styles.defaultSelectionContainer
                                }`}
                              >
                                {/* <div
                                  className={`${
                                    activeProduct === product?.name ||
                                    product?.name === hoverProduct
                                      ? Styles.sessionAction
                                      : Styles.sessionInactive
                                  }`}
                                ></div> */}
                                <div
                                  className={`${
                                    activeProduct === product?.name ||
                                    product?.name === hoverProduct
                                      ? ` ${Styles.sessionProductAction}`
                                      : Styles.sessionInactive
                                  }`}
                                ></div>

                                <IconToUse
                                  style={{ height: "15px", width: "15px" }}
                                />

                                <div className={`${Styles.roleText}`}>
                                  {product?.name === "Buy/Sell"
                                    ? getProductName(user)
                                    : product?.name}
                                </div>
                              </div>

                              <div
                                className={
                                  activeProduct === product?.name
                                    ? Styles.dropdownContentProduct
                                    : Styles.dropdownContentProductInactive
                                }
                              >
                                {(product?.name === "Buy/Sell"
                                  ? BuySellNav?.filter((ele) => ele?.view)
                                  : product?.name === "Banking"
                                  ? Banking
                                  : []
                                )?.map((user) => {
                                  const IconToUse =
                                    (activeLocation === user?.name ||
                                      hoverLocation === user?.name) &&
                                    user?.HoverIcon
                                      ? user.HoverIcon
                                      : user.Icon;

                                  const hasChildren =
                                    user?.children &&
                                    user?.children?.length > 0;
                                  const isExpanded =
                                    expandedProducts[user?.name];

                                  return (
                                    <div key={user.name}>
                                      <div
                                        className={`display_flex_row_gap_8_only ${
                                          Styles.userListSelection
                                        } ${
                                          (activeLocation === user?.name ||
                                            hoverLocation === user?.name) &&
                                          Styles.userListMainSelectionActive
                                        }`}
                                        onClick={() => {
                                          if (hasChildren) {
                                            handleProductToggle(user?.name);
                                            setActiveLocation(user?.name);
                                            navigate(user?.link);
                                          } else {
                                            setActiveLocation(user?.name);
                                            navigate(user?.link);
                                          }
                                        }}
                                      >
                                        <div
                                          onMouseEnter={() =>
                                            setHoverLocation(user?.name)
                                          }
                                          onMouseLeave={() =>
                                            setHoverLocation("")
                                          }
                                          className={`${
                                            activeLocation === user?.name ||
                                            hoverLocation === user?.name
                                              ? Styles.userListSelectionActive
                                              : Styles.userListSelectionInactive
                                          }`}
                                        ></div>

                                        <IconToUse
                                          style={{
                                            height: "15px",
                                            width: "15px",
                                          }}
                                        />

                                        <div className={`${Styles.userText}`}>
                                          {user?.name}
                                        </div>

                                        {hasChildren && (
                                          <KeyboardArrowDownIcon
                                            style={{
                                              fontSize: "14px",
                                              marginRight: "auto",
                                              transform: isExpanded
                                                ? "rotate(180deg)"
                                                : "rotate(0deg)",
                                              transition: "transform 0.3s ease",
                                            }}
                                          />
                                        )}
                                      </div>

                                      {/* Render children if they exist and are expanded */}
                                      {hasChildren && isExpanded && (
                                        <div
                                          className={Styles.subMenuContainer}
                                        >
                                          {user?.children?.map((child) => {
                                            const ChildIconToUse =
                                              (activeLocation ===
                                                child?.label ||
                                                hoverLocation ===
                                                  child?.label) &&
                                              child?.HoverIcon
                                                ? child.HoverIcon
                                                : child.Icon;

                                            return (
                                              <div
                                                key={child?.label}
                                                className={`display_flex_row_gap_8_only ${
                                                  Styles.userListSelection
                                                } ${
                                                  (activeLocation ===
                                                    child?.label ||
                                                    hoverLocation ===
                                                      child?.label) &&
                                                  Styles.userListMainSelectionActive
                                                }`}
                                                style={{ paddingLeft: "20px" }}
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  setActiveLocation(
                                                    child?.label
                                                  );

                                                  navigate(child?.link);
                                                }}
                                              >
                                                <div
                                                  onMouseEnter={() =>
                                                    setHoverLocation(
                                                      child?.label
                                                    )
                                                  }
                                                  onMouseLeave={() =>
                                                    setHoverLocation("")
                                                  }
                                                  className={`${
                                                    activeLocation ===
                                                      child?.label ||
                                                    hoverLocation ===
                                                      child?.label
                                                      ? Styles.userListSelectionActive
                                                      : Styles.userListSelectionInactive
                                                  }`}
                                                ></div>

                                                <ChildIconToUse
                                                  style={{
                                                    height: "15px",
                                                    width: "15px",
                                                  }}
                                                />

                                                <div
                                                  className={`${Styles.userText}`}
                                                >
                                                  {child?.label}
                                                </div>
                                              </div>
                                            );
                                          })}
                                        </div>
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  {data?.userType !== "COMPANY_ADMIN" && (
                    <div className={` ${Styles.profileLinkSection}`}>
                      <div className={` ${Styles.profileLink}`}>
                        {ProfileLinks?.filter((product) => {
                          if (
                            data?.userType === "BANKING" &&
                            (product?.name === "Unified Ledger" ||
                              product?.name === "Escrow")
                          ) {
                            return false;
                          }
                          return true;
                        })?.map((product) => {
                          const IconToUse =
                            (activeProfile === product?.name ||
                              hoverProduct === product?.name) &&
                            product?.HoverIcon
                              ? product.HoverIcon
                              : product.Icon;
                          return (
                            <div
                              key={product.name}
                              onMouseEnter={() =>
                                setHoverProduct(product?.name)
                              }
                              onMouseLeave={() => setHoverProduct("")}
                              onClick={() => {
                                if (product?.name === "Logout") {
                                  dispatch(logout());
                                  localStorage.setItem("OTC_V2_TOKEN", null);
                                  localStorage.clear();
                                  sessionStorage.clear();
                                  window.location = "/login";
                                } else {
                                  setActiveProfile(product?.name);
                                  navigate(product?.link);
                                }
                              }}
                            >
                              <div
                                className={`display_flex_row_gap_4_only ${
                                  activeProfile === product?.name
                                    ? Styles.roleContainerMainActiveProfile
                                    : Styles.roleContainerMain
                                }`}
                              >
                                <div
                                  className={`${
                                    activeProfile === product?.name ||
                                    product?.name === hoverProduct
                                      ? Styles.sessionAction
                                      : Styles.sessionInactive
                                  }`}
                                ></div>

                                <IconToUse
                                  style={{ height: "15px", width: "15px" }}
                                />

                                <div className={`${Styles.roleText}`}>
                                  {product?.name}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                  {(process.env.REACT_APP_ENV === "qa" ||
                    process.env.REACT_APP_ENV === "stage") && (
                    <div
                      onClick={() => setRaChange(true)}
                      className={`activeButton ${Styles.raDateButton}`}
                    >
                      RA Date TESTING
                    </div>
                  )}
                </div>
              </>
            )}
          </>
        ) : (
          <>
            {data?.userType === "SUPER_ADMIN" ? (
              <></>
            ) : (
              <>
                <div
                  className={`${Styles.collapsed_header}`}
                  onClick={onNavSwitch}
                >
                  <div onClick={onNavSwitch}>
                    <img
                      style={{ transform: "rotate(180deg)" }}
                      width={18}
                      height={18}
                      src={panelClose}
                      alt="Open Panel"
                      onClick={onNavSwitch}
                    />
                  </div>
                  <div className={Styles.side_nav_icon_collapsed}>
                    <span
                      style={{
                        display: "flex",
                        justifyContent: "left",
                        alignItems: "left",
                      }}
                    >
                      <img src={sidebarCompanyIcon} alt="sidebarCompanyIcon" />
                    </span>
                    <span className={Styles.collapsed_company_name}>
                      {company?.companyName || "Company Name"}
                    </span>
                  </div>

                  {/* <img
                    width={22}
                    height={22}
                    src={panelClose}
                    alt="Close Panel"
                    onClick={onNavSwitch}
                  /> */}
                </div>

                <div className={`scroll_bar_y ${Styles.collapsed_content}`}>
                  {/* User Section */}
                  <div className={Styles.collapsed_section}>
                    <div className={Styles.collapsed_section_title}>Entity</div>
                    {data?.roles?.map((role) => {
                      const Icon =
                        hoverRole === role || role === data?.userType
                          ? roleIconsHover[role] || BuySell
                          : roleIcons[role] || BuySell;
                      return (
                        <div
                          key={role}
                          className={`${Styles.collapsed_item} ${
                            role === data?.userType
                              ? Styles.collapsed_item_active
                              : ""
                          }`}
                          onMouseEnter={() => setHoverRole(role)}
                          onMouseLeave={() => setHoverRole("")}
                          onClick={() => {
                            if (
                              role === "BANKING" ||
                              role === "COMPANY_ADMIN"
                            ) {
                              if (role === "BANKING") {
                                handleSwitchUser(role);
                              } else {
                                handleSwitchUser(role, "");
                              }
                            } else if (
                              role === "CONSUMER" ||
                              role === "GENERATOR"
                            ) {
                              onNavSwitch();
                              setTimeout(() => {
                                handleUserSelect(role);
                              }, 100);
                            }
                          }}
                          title={
                            role === "CONSUMER"
                              ? "Buyer"
                              : role === "GENERATOR"
                              ? "Seller"
                              : role === "BANKING"
                              ? "Banking"
                              : role === "COMPANY_ADMIN"
                              ? "Company Admin"
                              : "User"
                          }
                        >
                          <Icon
                            className={`${Styles.collapsed_icon} ${
                              hoverRole === role ? Styles.iconHovered : ""
                            }`}
                            style={{
                              transition: "all 0.3s ease",
                            }}
                          />
                          <span
                            className={`${Styles.collapsed_label} ${
                              hoverRole === role || role === data?.userType
                                ? Styles.collapsed_label_hover
                                : ""
                            }`}
                          >
                            {role === "CONSUMER"
                              ? "Buyer"
                              : role === "GENERATOR"
                              ? "Seller"
                              : role === "BANKING"
                              ? "Banking"
                              : role === "COMPANY_ADMIN"
                              ? "Company Admin"
                              : "User"}
                          </span>
                        </div>
                      );
                    })}
                  </div>

                  {data?.userType !== "COMPANY_ADMIN" && (
                    <div className={Styles.collapsed_section}>
                      <div className={Styles.collapsed_section_title}>
                        Products
                      </div>
                      {(data?.userType === "BANKING"
                        ? ProductLinks_Banking
                        : ProductLinks_BuySell
                      )?.map((product) => {
                        const IconToUse =
                          (activeProduct === product?.name ||
                            hoverCollapsedProduct === product?.name) &&
                          product?.HoverIcon
                            ? product.HoverIcon
                            : product.Icon;
                        return (
                          <div key={product?.name}>
                            <div
                              className={`${Styles.collapsed_item} ${
                                activeProduct === product?.name
                                  ? ` ${Styles.collapsed_product_active}`
                                  : Styles.collapsed_item_inactive
                              }`}
                              onMouseEnter={() =>
                                setHoverCollapsedProduct(product?.name)
                              }
                              onMouseLeave={() => setHoverCollapsedProduct("")}
                              onClick={() => {
                                onNavSwitch();
                              }}
                              title={product?.name}
                            >
                              <IconToUse className={Styles.collapsed_icon} />
                              <span
                                className={`${Styles.collapsed_label} ${
                                  activeProduct === product?.name ||
                                  hoverCollapsedProduct === product?.name
                                    ? Styles.collapsed_label_hover
                                    : Styles.collapsed_label_inactive
                                }`}
                              >
                                {product?.name}
                              </span>
                            </div>

                            {activeProduct === product?.name && (
                              <div className={Styles.collapsed_sub_items}>
                                {(product?.name === "Banking"
                                  ? Banking
                                  : product?.name === "Buy/Sell"
                                  ? BuySellNav
                                  : []
                                )?.map((subItem) => {
                                  const IconToUse =
                                    (activeLocation === subItem?.name ||
                                      hoverCollapsedSubItem ===
                                        subItem?.name) &&
                                    subItem?.HoverIcon
                                      ? subItem.HoverIcon
                                      : subItem.Icon;

                                  const hasChildren =
                                    subItem?.children &&
                                    subItem?.children?.length > 0;
                                  const isExpanded =
                                    expandedProducts[subItem?.name];

                                  return (
                                    <div key={subItem.name}>
                                      <div
                                        className={`${
                                          Styles.collapsed_sub_item
                                        } ${
                                          activeLocation === subItem?.name
                                            ? Styles.collapsed_sub_item_active
                                            : ""
                                        }`}
                                        onMouseEnter={() =>
                                          setHoverCollapsedSubItem(
                                            subItem?.name
                                          )
                                        }
                                        onMouseLeave={() =>
                                          setHoverCollapsedSubItem("")
                                        }
                                        onClick={() => {
                                          if (hasChildren) {
                                            // handleProductToggle(subItem?.name);
                                            setActiveLocation(subItem?.name);
                                            navigate(subItem?.link);
                                          } else {
                                            setActiveLocation(subItem?.name);
                                            navigate(subItem?.link);
                                          }
                                        }}
                                        title={subItem?.name}
                                      >
                                        <IconToUse
                                          className={Styles.collapsed_sub_icon}
                                        />
                                        <span
                                          className={`${
                                            Styles.collapsed_sub_label
                                          } ${
                                            activeLocation === subItem?.name ||
                                            hoverCollapsedSubItem ===
                                              subItem?.name
                                              ? Styles.collapsed_label_hover
                                              : ""
                                          }`}
                                        >
                                          {subItem?.name}
                                        </span>
                                        {/* {hasChildren && (
                                          <KeyboardArrowDownIcon
                                            style={{
                                              fontSize: "12px",
                                              marginLeft: "auto",
                                              transform: isExpanded
                                                ? "rotate(180deg)"
                                                : "rotate(0deg)",
                                              transition: "transform 0.3s ease",
                                            }}
                                          />
                                        )} */}
                                      </div>

                                      {/* Render children if they exist and are expanded */}
                                      {hasChildren && isExpanded && (
                                        <div>
                                          {subItem?.children?.map((child) => {
                                            const ChildIconToUse =
                                              (activeLocation ===
                                                child?.label ||
                                                hoverCollapsedSubItem ===
                                                  child?.label) &&
                                              child?.HoverIcon
                                                ? child.HoverIcon
                                                : child.Icon;

                                            return (
                                              <div
                                                key={child?.label}
                                                className={`${
                                                  Styles.collapsed_sub_item
                                                } ${
                                                  activeLocation ===
                                                  child?.label
                                                    ? Styles.collapsed_sub_item_active
                                                    : ""
                                                }`}
                                                onMouseEnter={() =>
                                                  setHoverCollapsedSubItem(
                                                    child?.label
                                                  )
                                                }
                                                onMouseLeave={() =>
                                                  setHoverCollapsedSubItem("")
                                                }
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  setActiveLocation(
                                                    child?.label
                                                  );
                                                  navigate(child?.link);
                                                }}
                                                title={child?.label}
                                              >
                                                <ChildIconToUse
                                                  className={
                                                    Styles.collapsed_sub_icon
                                                  }
                                                />
                                                <span
                                                  className={`${
                                                    Styles.collapsed_sub_label
                                                  } ${
                                                    activeLocation ===
                                                      child?.label ||
                                                    hoverCollapsedSubItem ===
                                                      child?.label
                                                      ? Styles.collapsed_label_hover
                                                      : ""
                                                  }`}
                                                >
                                                  {child?.label}
                                                </span>
                                              </div>
                                            );
                                          })}
                                        </div>
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {/* Profile Section */}
                  {data?.userType !== "COMPANY_ADMIN" && (
                    <div className={` ${Styles.profile_collapsed_section}`}>
                      <div className={Styles.collapsed_section_title}>
                        Profile
                      </div>
                      {ProfileLinks?.filter((profile) => {
                        if (
                          data?.userType === "BANKING" &&
                          (profile?.name === "Unified Ledger" ||
                            profile.name === "Escrow")
                        ) {
                          return false;
                        }
                        return true;
                      })?.map((profile) => {
                        const IconToUse =
                          (activeProfile === profile?.name ||
                            hoverProfile === profile?.name) &&
                          profile?.HoverIcon
                            ? profile.HoverIcon
                            : profile.Icon;

                        return (
                          <div
                            key={profile.name}
                            className={`${Styles.collapsed_item} ${
                              activeProfile === profile?.name
                                ? Styles.collapsed_item_active
                                : ""
                            }`}
                            onMouseEnter={() => setHoverProfile(profile?.name)}
                            onMouseLeave={() => setHoverProfile("")}
                            onClick={() => {
                              if (profile?.name === "Logout") {
                                dispatch(logout());
                                localStorage.clear();
                                sessionStorage.clear();
                                window.location = "/login";
                              } else {
                                setActiveProfile(profile?.name);
                                navigate(profile?.link);
                              }
                            }}
                            title={profile.name}
                          >
                            <IconToUse className={Styles.collapsed_icon} />
                            <span
                              className={`${Styles.collapsed_label} ${
                                activeProfile === profile?.name ||
                                hoverProfile === profile?.name
                                  ? Styles.collapsed_label_hover
                                  : ""
                              }`}
                            >
                              {profile?.name}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default SideNavBar;
